module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.21865/images/academy/hubspot-academy-logo.svg"